const days = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

exports.dateToName = (date) =>{
    let d = new Date(date);
    return days[d.getDay()];
} 

exports.dateToReadable = (date) =>{
    let d = new Date(date);
    return `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`
} 
